import {
  GET_FEEDBACK_FAILED,
  GET_FEEDBACK_SUCCESS,
  GET_FEEDBACK_REQUEST,
  REMOVE_FEEDBACK_SUCCESS,
  REMOVE_FEEDBACK_FAILED,
  REMOVE_FEEDBACK_REQUEST,
} from '../Actions/FeedBack';
const FeedBackInitialState = {
  loading: false,
  FeedBackList: [],
  totalRows: 0,
};
export const FeedBackReducer = (state = FeedBackInitialState, action) => {
  switch (action.type) {
    case GET_FEEDBACK_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_FEEDBACK_SUCCESS:
      return {
        ...state,
        FeedBackList: action?.payload?.feedback_list,
        totalRows: action?.payload?.total,
        loading: false,
      };
    case GET_FEEDBACK_FAILED:
      return {
        ...state,
        loading: false,
      };
    case REMOVE_FEEDBACK_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case REMOVE_FEEDBACK_SUCCESS:
      return {
        ...state,
        FeedBackList:  state?.FeedBackList?.filter(
          (item) => item?.Id !== action?.payload
        ),        
        loading: false,
      };
    case REMOVE_FEEDBACK_FAILED:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
